import FAB from './FAB';

export default FAB;
